<template>
  <div class="wrapper">
    <h1>We're taking time out for maintenance</h1>
    <p>We'll be back soon</p>
    <img alt="Maintenance logo" src="/assets/2344483.png" />
  </div>
</template>

<script>
export default {
  props: {},
  data() {
    return {}
  },
}
</script>

<style scoped>
.wrapper {
  height: 100dvh;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  font-family: Rubik;
}
</style>
